import * as jwtDecode from 'jwt-decode';
import axios from 'axios';

// ----------------------------------------------------------------------

const isValidToken = (accessToken: any) => {
  if (!accessToken) {
    return false;
  }

  const decoded: any = jwtDecode.jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

//  const handleTokenExpired = (exp) => {
//   let expiredTimer;

//   window.clearTimeout(expiredTimer);
//   const currentTime = Date.now();
//   const timeLeft = exp * 1000 - currentTime;
//   console.log(timeLeft);
//   expiredTimer = window.setTimeout(() => {
//     console.log('expired');
//     // You can do what ever you want here, like show a notification
//   }, timeLeft);
// };

const setSession = (accessToken: any) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
    // Guardar el token no alcanza: si no queda también en el header por
    // defecto de axios, las llamadas que no pasan `auth` explícitamente salen
    // sin credenciales. Antes eso pasaba desapercibido porque los endpoints de
    // reservas no pedían nada; ahora sí.
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem('accessToken');
    delete axios.defaults.headers.common.Authorization;
  }
};

/**
 * Rehidrata el header de autorización al arrancar la app.
 *
 * Sin esto el header sólo quedaba puesto como efecto secundario de la primera
 * llamada que pasara `auth` (la de /auth/my-account del router), así que
 * cualquier request que saliera antes iba sin token. Con endpoints abiertos no
 * se notaba; al cerrarlos se convertiría en fallos intermitentes.
 */
const restoreSession = () => {
  const accessToken = localStorage.getItem('accessToken');
  if (accessToken && isValidToken(accessToken)) {
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    return true;
  }
  return false;
};

/**
 * Si la API responde 401 a un request autenticado (usuario borrado, token
 * vencido o inválido), la sesión local ya no sirve: la limpiamos y mandamos
 * al login. El reset de contraseña maneja su propio 401, así que lo dejamos.
 */
const logoutOnUnauthorized = () => {
  axios.interceptors.response.use(undefined, (error) => {
    const { response, config } = error || {};
    const isResetPassword = config?.url?.includes('/auth/new-password');
    if (
      response?.status === 401 &&
      !isResetPassword &&
      localStorage.getItem('accessToken')
    ) {
      setSession('');
      localStorage.removeItem('isFirstTime');
      window.location.assign('/login');
    }
    return Promise.reject(error);
  });
};

export { isValidToken, setSession, restoreSession, logoutOnUnauthorized };
